import { Table, SortableTableHeader } from "soprasteria-ui-library";
import * as React from "react";
import { formatDate } from "../../../../../helpers/DateHelper";
import { IContractAreaListItem } from "../../../../../models/IContractArea";


interface IProps {
    contractAreas: IContractAreaListItem[];
}

export const ContractAreaTable: React.FC<IProps> = ({ contractAreas }) => {

    return (
        <>
            <section>
                <Table>
                    <thead>
                        <tr>
                            <SortableTableHeader propertyToSortBy="ContractTypeName" headerText="Avtalsområdestyp" />
                            <SortableTableHeader propertyToSortBy="ContractNumber" headerText="Avtalsnummer" />
                            <SortableTableHeader propertyToSortBy="DateFrom" headerText="Fr.o.m." />
                            <SortableTableHeader propertyToSortBy="DateTo" headerText="T.o.m." />
                        </tr>
                    </thead>
                    <tbody>
                        {
                            contractAreas && contractAreas.length > 0
                                ? contractAreas.map((contractArea, key) => {
                                    return (
                                        <tr key={key}>
                                            <td>{contractArea.contractTypeName}</td>
                                            <td>{contractArea.contractNumber}</td>
                                            <td>{formatDate(contractArea.dateFrom)}</td>
                                            <td>{contractArea.dateTo ? formatDate(contractArea.dateTo) : "Tillsvidare"}</td>
                                        </tr>
                                    )
                                })
                                : <tr><td colSpan={4}>Det finns inga avtalsområden på denna vårdgivare</td></tr>
                        }
                    </tbody>
                </Table>
            </section>
        </>
    )
}